import { Story } from '@frontend/sports/types/components/story-content';

export function getStoryBackgroundImage(story: Story, stretch = false) {
    if (!story?.tileImage) {
        return undefined;
    }
    const imageUrl = new URL(story?.tileImage);
    const backgroundWidth = stretch ? '540' : '160';
    const qualityParam = `width${backgroundWidth}`;
    imageUrl.searchParams.set('p', qualityParam);

    return imageUrl.toString();
}
